import { render, staticRenderFns } from "./seniorDismissalStatusDetail.vue?vue&type=template&id=0715950b"
import script from "./seniorDismissalStatusDetail.vue?vue&type=script&lang=js"
export * from "./seniorDismissalStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0715950b')) {
      api.createRecord('0715950b', component.options)
    } else {
      api.reload('0715950b', component.options)
    }
    module.hot.accept("./seniorDismissalStatusDetail.vue?vue&type=template&id=0715950b", function () {
      api.rerender('0715950b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalStatusDetail.vue"
export default component.exports